module.exports = __webpack_public_path__ + "static/media/4wkndhardpost.cb66a721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4wkndhardpost.png
// module id = 104
// module chunks = 0